// Reusable DOM attribute bag for Matomo Heatmaps and Session Recordings.
// Apply this only to rendered values that may expose customer-related data.
const MATOMO_MASK = {
    "data-matomo-mask": true
};
export { MATOMO_MASK };
